// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {Link} from 'react-router-dom';
import { colors, btn, form, modal, search as searchStyles, chipWrap } from '../../../../style/common/partnerStyle';

function Toast({ message, type, onClose }) {
  if (!message) return null;
  const bg     = type === 'error' ? colors.dangerLt  : colors.successLt;
  const color  = type === 'error' ? colors.danger     : colors.success;
  const border = type === 'error' ? '#fca5a5'          : '#6ee7b7';
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px', borderRadius: 8, marginBottom: 16,
      background: bg, border: `1px solid ${border}`, fontSize: 13,
    }}>
      <span style={{ color, fontWeight: 600 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color, fontSize: 16, lineHeight: 1, padding: '0 0 0 12px' }}>✕</button>
    </div>
  );
}

//Copied from AddTournamentTeamMember - So the extra code.
class AddTournamentRegistration extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      tournament_id: props.tournament_id,
      team_id: props.team_id,
      team_name: props.team_name,
      customer_search_list: [],
      tournaments: [],
      tournament_teams: [],
      team_members: [],
      groups: [],
      age_groups: [],
      player_id: '', //the selected player.
      tournament_details: {
        mobile_no: '',
        customer_id: '',
        competition_id: props.competition_id,
        name: '',
        tournament_team: props.team_id,
        amount: 0,
        club_name: '',
        cust_name: '',
        cust_mobile_no: '',
        group: '',
        age_group: '',
      },
      venues: [],
      data_uploaded: false,
      data_error: false,
      search: false,
      search_loading: false,
      dialog_open: false,
      addPlayerView: true,
      toast: null,
      add_user_toast: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);

    this.chipStyle = { margin: 4 };
    this.chipWrapper = { display: 'flex', flexWrap: 'wrap' };
  }

  componentDidMount() {
    console.log(this.state);
    this.getTeamDetailInput();
  }

  showToast(message, type = 'error') {
    this.setState({ toast: { message, type } });
  }

  showAddUserToast(message, type = 'error') {
    this.setState({ add_user_toast: { message, type } });
  }

  getSearchList(mobile_no) {
    this.setState({ search_loading: true, toast: null });
    const url = `${getLocationOrigin()}/eagleeye/search/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'search': mobile_no });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        if (data.Message) {
          this.setState({ customer_search_list: [], search: false, search_loading: false });
          this.showToast(data.Message);
          return;
        }
        this.setState({
          customer_search_list: Array.isArray(data.results) ? data.results : [],
          search: true,
          search_loading: false,
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({ customer_search_list: [], search: false, search_loading: false });
        this.showToast(error && error.message ? error.message : 'Search failed. Please try again.');
      });
  }

  postaddTournamentRegistration(data, props) {
    console.log(data);
    if(this.state.tournament_details.customer_id && this.state.tournament_details.group) {
      const url = `${getLocationOrigin()}/tournament/add_tournament_registration/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = { 'content-type': 'application/json' };
      options['body'] = JSON.stringify(this.state.tournament_details);
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus).then(parseJSON)
        .then(function(response) {
          alert(response.message);
          window.location.reload();
        })
        .catch(error => {
          console.log(error);
          this.showToast(error && error.message ? error.message : 'Failed to add registration');
        });
    } else {
      this.showToast('Please fill required fields');
    }
  }

  handleOpen = () => { this.setState({ dialog_open: true }); };
  handleClose = () => { this.setState({ dialog_open: false, add_user_toast: null }); };

  handleChange(event) {
    console.log(event.target.name, event.target.value);
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = event.target.value;
    this.setState({ tournament_details: new_selected_one });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddTournamentRegistration(this.state.tournament_details, this.props);
    console.log('post');
    console.log(this.state);
  }

  handleCustomerSubmit() {
    console.log('post');
    if (!this.state.tournament_details.cust_name) { this.showAddUserToast('Enter name'); return; }
    if (!this.state.tournament_details.cust_mobile_no || String(this.state.tournament_details.cust_mobile_no).length !== 10) {
      this.showAddUserToast('Enter a valid 10-digit mobile number'); return;
    }
    const url = `${getLocationOrigin()}/eagleeye/add_new_customer_tournament/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({
      'customer_name': this.state.tournament_details.cust_name,
      'customer_mobile': this.state.tournament_details.cust_mobile_no,
      'tournament_id': this.state.tournament_id,
    });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .catch(error => {
        console.log(error);
        this.showAddUserToast(error && error.message ? error.message : 'Failed to add user');
      })
      .then(data => {
        if (!data) return;
        if(data.success) {
          var team_members = [];
          team_members.push({ 'id': data.customer.id, 'name': data.customer.name, 'photo': "http://www.sporthood.in/assets/img/avatar.png" });
          this.setState({ team_members: team_members });
          this.handleClose();
        } else {
          this.showAddUserToast(data.message || 'Something went wrong');
        }
      });
  }

  getTeamDetailInput() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_team/`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ groups: data.groups, age_groups: data.age_groups }); })
      .catch(error => error);
  }

  searchCustomer() {
    const term = this.state.tournament_details.mobile_no;
    if (!term || String(term).trim() === '') { this.showToast('Search cannot be blank'); return; }
    if (String(term).trim().length < 3) { this.showToast('Enter at least 3 characters to search'); return; }
    this.getSearchList(term);
  }

  setSearch(name, mobile, id) {
    var new_selected_one = Object.assign({}, this.state.tournament_details);
    var team_members = []; //Show only one player for now.
    team_members.push({ 'id': id, 'name': name, 'photo': "http://www.sporthood.in/assets/img/avatar.png" });
    new_selected_one['mobile_no'] = mobile;
    new_selected_one['name'] = name;
    new_selected_one['customer_id'] = id;
    this.setState({ player_id: id, tournament_details: new_selected_one, search: false, team_members: team_members, customer_search_list: [] });
  }

  handleRequestDelete = (key) => {
    var team_members = Object.assign([], this.state.team_members);
    console.log(team_members);
    const chipToDelete = team_members.findIndex(chip => chip.id == key);
    team_members.splice(chipToDelete, 1);
    this.setState({ team_members: team_members });
  };

  toAdd() { this.setState({ addPlayerView: !this.state.addPlayerView }); }

  renderChip(data) {
    return (
      <Chip key={data.id} onRequestDelete={() => this.handleRequestDelete(data.id)} style={this.chipStyle}>
        <Avatar id={data.id} src={data.photo == 'http://www.sporthood.in/assets/img/avatar.png' ? data.photo : `https://api.sporthood.in/${data.photo}`} />
        {data.name}
      </Chip>
    );
  }

  render() {
    const actions = [
      <FlatButton label="Cancel" primary={true} onClick={this.handleClose} />,
      <FlatButton label="Submit" primary={true} onClick={this.handleCustomerSubmit} />,
    ];
    console.log("her in render");
    console.log(this.state.team_members);

    const { search, search_loading, customer_search_list, toast, add_user_toast } = this.state;

    return (
      <div>
        {this.state.addPlayerView &&
          <Dialog
            modal={false}
            open={true}
            autoDetectWindowHeight={true}
            autoScrollBodyContent={true}
            scroll={scroll}
            dividers={scroll === 'paper'}
          >
            <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", padding: '28px 28px 24px', minWidth: 480 }}>

              <h3 style={modal.title}>Add Registration</h3>

              {/*
              <div style={{flexDirection: 'column'}}>
                <button className="btn" style={{border: 'none', backgroundColor: '#fff', float: 'left', margin: '13px'}}>
                  <Link to={`/crud/childProfile/${this.state.tournament_details.mobile_no}`}>
                    <i className="fa fa-plus-circle" style={{fontSize: 'large'}}></i>
                    <span style={{fontSize: '100%', fontWeight: 600, margin: '4px'}}>Add Kid Profile</span>
                  </Link>
                </button>
              </div> */}

              <Toast
                message={toast && toast.message}
                type={toast && toast.type}
                onClose={() => this.setState({ toast: null })}
              />

              <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                {/* Customer search */}
                <div style={form.row}>
                  <div style={form.label}>Customer Search</div>
                  <div style={form.searchWrap}>
                    <input
                      type="text"
                      name="mobile_no"
                      placeholder="Search (min 3 chars)…"
                      style={form.searchInput}
                      value={this.state.tournament_details.mobile_no}
                      onChange={this.handleChange}
                      onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), this.searchCustomer())}
                    />
                    <button
                      type="button"
                      style={{ ...form.searchBtn, opacity: search_loading ? 0.6 : 1 }}
                      onClick={this.searchCustomer}
                      disabled={search_loading}
                    >
                      {search_loading ? '…' : '🔍'}
                    </button>
                  </div>
                </div>

                {/* Search results */}
                {search && (
                  <div style={{ marginBottom: 14, paddingLeft: 152 }}>
                    {customer_search_list.length ? (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {customer_search_list.map(x => (
                          <button
                            key={x.id}
                            type="button"
                            style={{ ...btn.outline, fontSize: 12, padding: '6px 12px' }}
                            onClick={() => this.setSearch(x.name, x.mobile_no, x.id)}
                          >
                            {x.name}: {x.mobile_no}
                          </button>
                        ))}
                      </div>
                    ) : (
                      <div style={searchStyles.notFound}>
                        <span style={searchStyles.notFoundText}>Search customer not found</span>
                        <button
                          type="button"
                          style={{ ...btn.primary, padding: '6px 12px', fontSize: 12 }}
                          onClick={this.handleOpen}
                        >+ Add User</button>
                      </div>
                    )}
                  </div>
                )}

                {/* Selected player */}
                <div style={form.row}>
                  <div style={form.label}>Selected Player</div>
                  <div style={chipWrap}>{this.state.team_members.map(this.renderChip, this)}</div>
                </div>

                {/*<div style={form.row}>
                  <div style={form.label}>Tournament Team</div>
                  <div style={{ flex: 1, fontSize: 13, color: colors.text }}>{this.state.team_name}</div>
                </div>*/}

                <div style={form.row}>
                  <div style={form.label}>Group</div>
                  <select name="group" style={form.select} value={this.state.value} onChange={(e) => this.handleChange(e)}>
                    <option key={-1} value={null}>select……</option>
                    {this.state.groups.map((x, index) => (
                      <option key={index} value={x}>{x}</option>
                    ))}
                  </select>
                </div>

                <div style={form.row}>
                  <div style={form.label}>Category</div>
                  <select name="age_group" style={form.select} value={this.state.value} onChange={(e) => this.handleChange(e)}>
                    <option key={-1} value={null}>select……</option>
                    {this.state.age_groups.map((x, index) => (
                      <option key={x.id} selected={this.state.team_details && this.state.team_details.age_groups && x.id == this.state.team_details.age_groups.id && x.id} value={x.id}>{x.name}</option>
                    ))}
                  </select>
                </div>

                <div style={form.row}>
                  <div style={form.label}>Amount Collected/Player</div>
                  <input type="number" name="amount" style={form.input} className="required" value={this.state.value} onChange={this.handleChange} />
                </div>

                <div style={form.row}>
                  <div style={form.label}>Club / Academy Name</div>
                  <input type="text" name="club_name" style={form.input} className="required" value={this.state.value} onChange={this.handleChange} />
                </div>

                <div style={modal.footer}>
                  <button type="button" style={btn.cancel} onClick={() => { this.toAdd(); }}>Cancel</button>
                  <button type="submit" style={btn.primary}>Submit</button>
                </div>

              </form>
            </div>

            {/* Add New Customer nested dialog */}
            <Dialog
              actions={actions}
              modal={false}
              open={this.state.dialog_open}
              onRequestClose={this.handleClose}
            >
              <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", padding: '24px 24px 20px', minWidth: 400 }}>
                <h3 style={{ ...modal.title, marginBottom: 16 }}>Add New Customer</h3>

                <Toast
                  message={add_user_toast && add_user_toast.message}
                  type={add_user_toast && add_user_toast.type}
                  onClose={() => this.setState({ add_user_toast: null })}
                />

                <div style={form.row}>
                  <div style={form.label}>Name</div>
                  <input type="text" style={form.input} name="cust_name" className="required" value={this.state.value} onChange={this.handleChange} />
                </div>
                <div style={form.row}>
                  <div style={form.label}>Mobile No</div>
                  <input type="number" style={form.input} name="cust_mobile_no" className="required" value={this.state.value} onChange={this.handleChange} />
                </div>

                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20, paddingTop: 16, borderTop: `1px solid ${colors.border}` }}>
                  <button type="button" style={btn.cancel} onClick={this.handleClose}>Cancel</button>
                  <button type="button" style={btn.primary} onClick={this.handleCustomerSubmit}>Submit</button>
                </div>
              </div>
            </Dialog>

          </Dialog>
        }
      </div>
    );
  }
}

export default AddTournamentRegistration;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentRegistration/index.js